<boels-product-thumbnail
  [product]="orderEntry().product!"
></boels-product-thumbnail>

<boels-product-identifier
  [product]="orderEntry().product!"
></boels-product-identifier>

<boels-product-title
  [product]="orderEntry().product!"
  [variant]="type()"
  (click)="canCollapse() && toggleCollapse()"
  [ngClass]="{ 'collapse-indicator': canCollapse() }"
>
  @if (canCollapse()) {
    @if (isCollapsed) {
      <fa-icon [icon]="faChevronDown" class="chevron"></fa-icon>
    } @else {
      <fa-icon [icon]="faChevronUp" class="chevron"></fa-icon>
    }
  }
</boels-product-title>

@if (variant() === 'edit') {
  @if (!isCollapsed) {
    <div
      class="order-entry-item__description"
      [innerHTML]="orderEntry().product!.description | safeHtml"
    ></div>
  }

  <boels-product-price
    [product]="orderEntry().product!"
    [type]="type()"
  ></boels-product-price>
}

@if (orderEntry().isMandatory) {
  <boels-order-entry-accessory-label
    [variant]="'mandatory'"
  ></boels-order-entry-accessory-label>
}

@if (variant() === 'edit') {
  <boels-quantity
    [value]="orderEntry().quantity!"
    [editSettings]="{
      min: orderEntry().minQuantity,
    }"
    [hasAutoFocus]="orderEntry().product?.code === autoFocusTarget()"
    (quantityChanged)="
      orderEntry().quantity = $event;
      type() === 'main' && mainQuantityChanged.emit($event)
    "
  ></boels-quantity>
} @else {
  <boels-order-entry-product-quantity
    [value]="orderEntry().quantity!"
    (click)="entryEditRequested.emit(orderEntry())"
  ></boels-order-entry-product-quantity>
}

@if (orderEntry().entryNumber !== undefined) {
  <boels-order-entry-delete
    [orderEntry]="orderEntry()"
    (deleteOrderEntry)="deleteOrderEntry.emit($event)"
  ></boels-order-entry-delete>
}
